import React from 'react';

const IconHotel = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 512 512" {...props}>
      <path
        fill="#9A0167"
        d="M193.188 147.678L193.184 120.247C193.178 114.336 190.692 103.137 197.594 102.324L300.64 102.309C321.483 102.295 319.022 100.62 319.023 119.921L319.008 147.678C324.859 147.667 331.067 147.528 336.92 147.767C343.377 148.031 341.474 159.788 341.47 164.585L341.461 247.539L390.523 247.454C398.178 247.407 395.491 260.661 395.491 266.565L395.496 399.33C401.122 399.317 419.104 396.631 418.725 404.755C418.42 411.294 408.369 409.433 404.063 409.424L312.125 409.414L122.067 409.419C114.023 409.422 105.997 409.455 97.9191 409.345C90.5462 409.244 87.1019 399.241 102.228 399.319L116.628 399.33L116.619 268.568C116.571 245.063 113.025 247.528 137.853 247.526L170.674 247.539L170.668 164.472C170.609 143.362 169.775 147.606 193.188 147.678ZM202.949 112.163L202.581 112.428C203.343 123.245 202.954 136.672 202.949 147.678L309.119 147.678L309.455 147.357C309.01 141.997 309.107 137.236 309.107 131.856L309.119 112.163L238.413 112.158C227.027 112.158 214.248 111.865 202.949 112.163ZM180.525 157.509L180.525 399.33L229.488 399.33L229.5 368.516C229.491 348.178 230.146 340.923 252.986 341.064L264.08 341.096C282.726 341.23 282.853 352.975 282.809 367.812L282.803 389.625L282.803 399.33L331.518 399.33L331.518 157.509L180.525 157.509ZM341.461 257.271C341.132 272.629 341.46 289.109 341.46 304.594L341.461 399.33L385.695 399.33C385.943 394.898 385.703 388.6 385.698 384.009L385.695 257.271L341.461 257.271ZM126.457 257.271L126.457 399.33L155.989 399.337C160.25 399.337 166.553 399.546 170.674 399.33L170.674 257.271L126.457 257.271ZM244.276 350.994C237.116 353.709 239.305 365.225 239.308 371.894L239.325 399.33L268.207 399.33L273.152 399.33L273.164 371.243C273.163 363.494 275.77 350.679 264.814 351.018C258.196 351.223 250.828 350.561 244.276 350.994Z"
      />
      <path
        fill="#9A0167"
        d="M241.235 134.489C237.43 134.464 225.29 135.326 223.47 133.159C219.851 128.852 222.855 124.753 228.507 124.627C232.37 124.609 244.075 123.819 246.22 126.069C249.851 129.878 246.657 134.369 241.235 134.489Z"
      />
      <path
        fill="#9A0167"
        d="M287.14 134.489C283.509 134.691 269.92 135.035 267.179 133.789C262.783 131.791 264.107 125.938 268.207 124.627C273.707 124.381 292.772 122.175 290.398 130.816C289.882 132.694 288.874 133.571 287.14 134.489Z"
      />
      <path
        fill="#9A0167"
        d="M216.567 200.494C208.16 200.198 208.234 182.594 215.334 181.032C218.127 181.237 219.308 182.088 220.93 184.303C220.914 189.443 223.034 198.779 216.567 200.494Z"
      />
      <path
        fill="#9A0167"
        d="M257.329 200.494C248.831 202.047 248.554 183.938 254.838 181.032C263.483 180.153 263.903 197.642 257.329 200.494Z"
      />
      <path
        fill="#9A0167"
        d="M297.37 200.494C289.056 201.049 288.9 183.607 295.32 181.032C304.016 180.376 303.963 198.183 297.37 200.494Z"
      />
      <path
        fill="#9A0167"
        d="M216.567 237.938C208.301 238.286 208.285 221.187 215.334 219.553C223.15 219.425 223.434 235.636 216.567 237.938Z"
      />
      <path
        fill="#9A0167"
        d="M257.329 237.938C248.214 238.486 248.903 222.099 254.838 219.553C263.915 219.109 263.301 235.451 257.329 237.938Z"
      />
      <path
        fill="#9A0167"
        d="M296.135 237.938C289.323 238.291 288.593 221.267 296.135 219.553C302.687 219.663 305.468 236.175 296.135 237.938Z"
      />
      <path
        fill="#9A0167"
        d="M216.567 277.328C208.234 278.572 208.613 261.267 214.568 258.777C222.799 258.529 220.853 268.25 220.93 274.125C219.555 276.114 218.723 276.477 216.567 277.328Z"
      />
      <path
        fill="#9A0167"
        d="M257.329 277.328C249.899 279.033 247.497 262.469 254.838 258.777C263.787 257.9 263.92 274.652 257.329 277.328Z"
      />
      <path
        fill="#9A0167"
        d="M297.37 277.328C289.295 278.075 288.457 261.833 295.32 258.777C303.737 258.228 304.103 274.763 297.37 277.328Z"
      />
      <path
        fill="#9A0167"
        d="M297.37 315.998C289.244 316.163 288.013 299.778 296.135 298.048C303.829 297.866 304.049 313.786 297.37 315.998Z"
      />
      <path
        fill="#9A0167"
        d="M216.567 315.998C208.335 316.002 208.106 299.243 215.334 298.048C222.622 298.61 221.155 307.593 220.93 312.983C219.369 314.607 218.597 315.154 216.567 315.998Z"
      />
      <path
        fill="#9A0167"
        d="M252.301 299.442C253.665 298.546 254.046 298.375 255.64 298.048C263.303 297.981 264.121 313.504 256.668 315.998C249.106 316.043 249.938 303.575 252.301 299.442Z"
      />
    </svg>
  );
};

export default IconHotel;
